import PageHeader from "~/components/page-header";

function NotFoundPage() {
  return <PageHeader />;
}

export default NotFoundPage;
